function initRestrictedHeader() {
  
  // 1. Header Positioning Logic (Mobile)
  const updateHeaderPosition = () => {
    const headerWrapper = document.querySelector('.mobile-header-wrapper');
    if (headerWrapper) {
      const rect = headerWrapper.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom-pos', `${rect.bottom}px`);
    }
  };
  
  updateHeaderPosition();
  window.addEventListener('resize', updateHeaderPosition);
  window.addEventListener('scroll', updateHeaderPosition);

  // 2. Mobile Menu Logic
  const mobileMenuToggle = document.getElementById('MobileMenuToggle');
  const mobileDrawer = document.getElementById('MobileDrawer');
  const body = document.body;

  if(mobileMenuToggle && mobileDrawer) {
    const newToggle = mobileMenuToggle.cloneNode(true);
    mobileMenuToggle.parentNode.replaceChild(newToggle, mobileMenuToggle);
    const activeToggle = document.getElementById('MobileMenuToggle');

    activeToggle.addEventListener('click', (e) => {
      e.stopPropagation(); 
      const isOpen = mobileDrawer.classList.contains('is-open');
      if (isOpen) {
        mobileDrawer.classList.remove('is-open');
        activeToggle.classList.remove('is-active');
        activeToggle.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
        setTimeout(() => {
           document.querySelectorAll('.submenu-view').forEach(el => el.classList.remove('is-active'));
           const mainView = document.getElementById('MobileMainView');
           if(mainView) mainView.classList.add('is-active');
           document.querySelectorAll('.mobile-accordion-panel').forEach(el => el.style.maxHeight = null);
           document.querySelectorAll('.mobile-accordion-toggle').forEach(el => {
             el.classList.remove('is-active');
             el.setAttribute('aria-expanded', 'false');
           });
        }, 300);
      } else {
        const searchBar = document.getElementById('MobileSearchBar');
        if (searchBar) searchBar.classList.remove('is-visible');
        body.style.overflow = 'hidden';
        requestAnimationFrame(() => updateHeaderPosition());
        mobileDrawer.classList.add('is-open');
        activeToggle.classList.add('is-active');
        activeToggle.setAttribute('aria-expanded', 'true');
      }
    });

    const triggers = document.querySelectorAll('.submenu-trigger');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const targetView = document.getElementById(targetId);
        if(targetView) targetView.classList.add('is-active');
      });
    });
    
    const backBtns = document.querySelectorAll('.mobile-back-btn');
    backBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const parentView = this.closest('.submenu-view');
        if(parentView) parentView.classList.remove('is-active');
      });
    });

    const accToggles = document.querySelectorAll('.mobile-accordion-toggle');
    accToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        this.classList.toggle('is-active');
        const isExpanded = this.classList.contains('is-active');
        this.setAttribute('aria-expanded', isExpanded);
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) { panel.style.maxHeight = null; } 
        else { panel.style.maxHeight = panel.scrollHeight + "px"; }
      });
    });
  }

  // 3. Mobile Search Logic
  const mobileSearchToggle = document.getElementById('MobileSearchToggle');
  const mobileSearchBar = document.getElementById('MobileSearchBar');
  if(mobileSearchToggle && mobileSearchBar) {
    const newSearchToggle = mobileSearchToggle.cloneNode(true);
    mobileSearchToggle.parentNode.replaceChild(newSearchToggle, mobileSearchToggle);
    const activeSearchToggle = document.getElementById('MobileSearchToggle');

    activeSearchToggle.addEventListener('click', () => {
      const activeMenuToggle = document.getElementById('MobileMenuToggle');
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        mobileDrawer.classList.remove('is-open');
        if(activeMenuToggle) {
            activeMenuToggle.classList.remove('is-active');
            activeMenuToggle.setAttribute('aria-expanded', 'false');
        }
        body.style.overflow = '';
      }
      mobileSearchBar.classList.toggle('is-visible');
      activeSearchToggle.setAttribute('aria-expanded', mobileSearchBar.classList.contains('is-visible'));
      if(mobileSearchBar.classList.contains('is-visible')) mobileSearchBar.querySelector('input').focus();
    });
  }

  // 4. Language Selector Logic (Desktop)
  const langBtn = document.getElementById('LangSelectorBtn');
  const langList = document.getElementById('LangDropdownList');
  const langForm = document.getElementById('header_localization_form');
  const langInput = document.getElementById('LocaleCodeInput');
  const langLinks = document.querySelectorAll('.lang-item a');
  
  if(langBtn && langList) {
    const newLangBtn = langBtn.cloneNode(true);
    langBtn.parentNode.replaceChild(newLangBtn, langBtn);
    
    newLangBtn.addEventListener('click', (e) => { 
      e.stopPropagation(); 
      langList.classList.toggle('is-open'); 
      const isOpen = langList.classList.contains('is-open');
      newLangBtn.classList.toggle('is-active'); 
      newLangBtn.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', (e) => { 
      if (!langList.contains(e.target) && !newLangBtn.contains(e.target)) { 
        langList.classList.remove('is-open'); 
        newLangBtn.classList.remove('is-active'); 
        newLangBtn.setAttribute('aria-expanded', 'false');
      } 
    });
    langLinks.forEach(link => { 
        link.addEventListener('click', function(e) { 
            e.preventDefault(); 
            if(langInput) { 
                langInput.value = this.getAttribute('data-value'); 
                langForm.submit(); 
            } 
        }); 
    });
  }

  // 5. Mobile Language Logic
  const mobileLangBtn = document.getElementById('MobileHeaderLangBtn');
  const mobileLangList = document.getElementById('MobileHeaderLangList');
  if(mobileLangBtn && mobileLangList) {
    const mForm = document.getElementById('mobile_header_localization_form');
    const mInput = document.getElementById('MobileHeaderLocaleCodeInput');
    const mItems = document.querySelectorAll('.mobile-lang-item');
    
    const newMobileLangBtn = mobileLangBtn.cloneNode(true);
    mobileLangBtn.parentNode.replaceChild(newMobileLangBtn, mobileLangBtn);

    newMobileLangBtn.addEventListener('click', (e) => { 
        e.stopPropagation(); 
        mobileLangList.classList.toggle('is-open'); 
        newMobileLangBtn.setAttribute('aria-expanded', mobileLangList.classList.contains('is-open'));
    });
    mItems.forEach(item => { 
        item.addEventListener('click', function() { 
            if(mInput) { 
                mInput.value = this.getAttribute('data-value'); 
                mForm.submit(); 
            } 
        }); 
    });
    document.addEventListener('click', (e) => { 
        if(!newMobileLangBtn.contains(e.target) && !mobileLangList.contains(e.target)) {
            mobileLangList.classList.remove('is-open'); 
            newMobileLangBtn.setAttribute('aria-expanded', 'false');
        }
    });
  }

  // 6. MODAL & LOCATION LOGIC
  const modal = document.getElementById('LocationModal');
  const locTriggers = [
    document.getElementById('LocationModalTrigger'), 
    document.getElementById('MobileLocationTrigger')
  ];
  const closeBtn = document.getElementById('ModalCloseBtn');
  const csWrapper = document.getElementById('CustomSelectWrapper');
  const goToBtn = document.getElementById('GoToSiteBtn');

  // Open Modal Triggers
  locTriggers.forEach(btn => { 
      if(btn) {
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);
          
          newBtn.addEventListener('click', (e) => { 
              e.preventDefault(); 
              if(mobileDrawer) mobileDrawer.classList.remove('is-open'); 
              const activeMenuToggle = document.getElementById('MobileMenuToggle');
              if(activeMenuToggle) { 
                  activeMenuToggle.classList.remove('is-active'); 
                  activeMenuToggle.setAttribute('aria-expanded', 'false'); 
              } 
              body.style.overflow = ''; 
              if(modal) modal.classList.add('is-open'); 
          }); 
      }
  });

  // Close Modal (X Button)
  if(closeBtn) {
      const newClose = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newClose, closeBtn);
      newClose.addEventListener('click', () => {
         if(modal) modal.classList.remove('is-open');
      });
  }

  // Close Modal (Click Outside)
  window.addEventListener('click', function(e) {
    if (modal && e.target == modal) {
      modal.classList.remove('is-open');
    }
  });

  // 7. Custom Select Dropdown Logic (FIXED REFERENCE ISSUE)
  if (csWrapper) {
    const trigger = csWrapper.querySelector('.custom-select-trigger');
    const options = csWrapper.querySelectorAll('.custom-option');
    
    if(trigger) {
        // Clone trigger to clean events
        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);

        // **IMPORTANT:** Since we cloned the trigger, the old 'SelectedText' element inside it 
        // is now detached. We must get the reference to the NEW span inside the NEW trigger.
        const currentSelectedText = newTrigger.querySelector('#SelectedText') || document.getElementById('SelectedText');

        newTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); 
            csWrapper.classList.toggle('open');
        });

        // Add listeners to options
        options.forEach(opt => {
          opt.onclick = function(e) { 
              e.stopPropagation();
              
              // 1. Update Visual Text using the CORRECT reference
              if(currentSelectedText) {
                  currentSelectedText.textContent = this.textContent; 
              }
              
              // 2. Update Go Button Link
              const url = this.getAttribute('data-value');
              if(goToBtn) {
                goToBtn.href = url;
                if(url && url !== '#') {
                    goToBtn.style.pointerEvents = 'auto';
                    goToBtn.style.opacity = '1';
                } else {
                    goToBtn.style.pointerEvents = 'none';
                    goToBtn.style.opacity = '0.5';
                }
              }

              // 3. Close Dropdown
              csWrapper.classList.remove('open'); 
          };
        });
    }

    // Close select on outside click
    document.addEventListener('click', (e) => {
        if (!csWrapper.contains(e.target)) {
            csWrapper.classList.remove('open');
        }
    });
  }
  
  // Initialize Go Button State
  if(goToBtn) {
     const currentHref = goToBtn.getAttribute('href');
     if(!currentHref || currentHref === '#' || currentHref === '') {
        goToBtn.style.pointerEvents = 'none';
        goToBtn.style.opacity = '0.5';
     }
  }

  // 8. Cart Icon Linking
  const mCart = document.getElementById('cart-icon-bubble-mobile');
  const dCart = document.getElementById('cart-icon-bubble');
  if (mCart && dCart) {
      const newMCart = mCart.cloneNode(true);
      mCart.parentNode.replaceChild(newMCart, mCart);
      
      newMCart.addEventListener('click', (e) => { 
          e.preventDefault(); 
          dCart.click(); 
      });
  }
}

// Initialize on Page Load
document.addEventListener('DOMContentLoaded', initRestrictedHeader);

// Initialize on Theme Editor Changes
document.addEventListener('shopify:section:load', initRestrictedHeader);